var map = {
	"./addTeacher.svg": "4f32",
	"./adminconsole.svg": "10f0",
	"./announcement.svg": "bf2e",
	"./announcementGroup.svg": "e5b1",
	"./attendance.svg": "2e11",
	"./classes.svg": "877c",
	"./classes_app.svg": "5297",
	"./commbk.svg": "20ef",
	"./commbook.svg": "4aa3",
	"./companies.svg": "5711",
	"./general.svg": "c5ad",
	"./globalCommbook.svg": "c52d",
	"./journal.svg": "0b44",
	"./locations.svg": "29e9",
	"./moments.svg": "b54e",
	"./newsletterTemplates.svg": "6053",
	"./parents.svg": "acc2",
	"./people.svg": "8745",
	"./product_app.svg": "a4c1",
	"./removeTeacher.svg": "41a9",
	"./roles.svg": "068e",
	"./settings.svg": "41a1",
	"./staff.svg": "163f",
	"./staff_add.svg": "4ebf",
	"./staff_delete.svg": "0faec",
	"./students.svg": "225b",
	"./users.svg": "77bf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e46";